<template>
  <div class="drawer">
    <el-drawer
      size="800px"
      title="预约详情"
      :visible.sync="drawerStatus"
      @close="handleClose"
    >
      <el-scrollbar class="bor" style="height: 100%">
        <div class="page">
          <div style="padding: 15px; background: #f5f5f5">预约客户</div>
          <div style="padding: 15px">
            <el-row>
              <!-- 1 洗美 2 医疗 3 寄养 4 看宠 -->
              <el-col :span="6"
                ><div>预约类型:{{ reserveList[reserveType - 1] }}</div></el-col
              >
              <el-col :span="6"
                ><div>提交时间:{{ operationTime }}</div></el-col
              >
              <el-col :span="6"
                ><div>客户姓名:{{ userName }}</div></el-col
              >
              <el-col :span="6"
                ><div>客户电话:{{ linkmanMobile }}</div></el-col
              >
            </el-row>
          </div>

          <!-- 看宠 -->
          <div
            style="padding: 15px; background: #f5f5f5"
            v-if="reserveType == 4"
          >
            预约信息
          </div>
          <div style="padding: 15px" v-if="reserveType == 4">
            <el-row>
              <el-col :span="6"
                ><div>预约日期:{{ reserveDate }}</div></el-col
              >
              <el-col :span="6"
                ><div>意向宠物:{{ seePetInfo.petType.name }}</div></el-col
              >
              <el-col :span="6"
                ><div>意向品种{{ seePetInfo.petClass.name }}</div></el-col
              >
              <el-col :span="6"
                ><div>预约备注:{{ remark ? remark : "无" }}</div></el-col
              >
            </el-row>
          </div>
          <!-- 看宠结束 -->

          <!-- 寄养 -->
          <div
            style="padding: 15px; background: #f5f5f5"
            v-if="reserveType == 3"
          >
            预约信息
          </div>
          <div v-if="reserveType == 3">
            <div style="padding: 15px">
              <el-row>
                <el-col :span="12"
                  ><div>预约日期:{{ reserveDate }}</div></el-col
                >
                <el-col :span="12"
                  ><div>预约备注:{{ remark ? remark : "无" }}</div></el-col
                >
              </el-row>
            </div>
            <div style="padding: 15px; background: #f5f5f5">预约宠物</div>
            <div style="padding: 15px">
              <el-row v-for="item in fosterInfo.petName" :key="item.petId">
                <el-col :span="6"
                  ><div>宠物名字:{{ item }}</div></el-col
                >
              </el-row>
            </div>
          </div>
          <!-- 寄养结束 -->
          <!-- 医疗 -->
          <div v-if="reserveType == 2">
            <div style="padding: 15px; background: #f5f5f5">预约信息</div>
            <div style="padding: 15px">
              <el-row>
                <el-col :span="8"
                  ><div>预约日期:{{ reserveDate }}</div></el-col
                >
                <el-col :span="8"
                  ><div>预约项目:{{ medicalInfo.medicalPro.name }}</div></el-col
                >
                <el-col :span="8"
                  ><div>预约备注:{{ remark ? remark : "无" }}</div></el-col
                >
              </el-row>
            </div>
            <div style="padding: 15px; background: #f5f5f5">预约宠物</div>
            <div style="padding: 15px">
              <el-row>
                <el-col :span="6"
                  ><div>宠物名字:{{ this.medicalInfo.petName }}</div></el-col
                >
              </el-row>
            </div>
          </div>
          <!-- 医疗结束 -->
          <!-- 回访 -->
          <div v-if="state !== 1">
            <div style="padding: 15px; background: #f5f5f5">回访确定</div>
            <div style="padding: 15px">
              <el-row style="margin-bottom: 16px">
                <el-col :span="6"
                  ><div>
                    回访人员:{{ updateOperationInfo.userName }}
                  </div></el-col
                >
                <el-col :span="6"
                  ><div>
                    回访时间:{{ updateOperationInfo.operationTime }}
                  </div></el-col
                >
              </el-row>
              <el-row>
                <el-col :span="6"
                  ><div>
                    确定备注:{{
                      confirmInfo.confirmRemark
                        ? confirmInfo.confirmRemark
                        : "无"
                    }}
                  </div></el-col
                >
              </el-row>
            </div>
          </div>
          <!-- 已到店 -->
          <div v-if="state == 3">
            <div style="padding: 15px; background: #f5f5f5">预约结果</div>
            <div style="padding: 15px">
              <el-row style="margin-bottom: 16px">
                <el-col :span="6"><div>预约状态:已到店</div></el-col>
                <el-col :span="6"
                  ><div>
                    操作人员:{{ updateOperationInfo.userName }}
                  </div></el-col
                >
                <el-col :span="6"
                  ><div>
                    操作时间:{{ updateOperationInfo.operationTime }}
                  </div></el-col
                >
              </el-row>
              <el-row>
                <el-col :span="6"
                  ><div>到店时间:{{ arrivalInfo.operationTime }}</div></el-col
                >
                <el-col :span="6"
                  ><div>
                    到店备注:{{
                      arrivalInfo.arrivalReamrk
                        ? arrivalInfo.arrivalReamrk
                        : "无"
                    }}
                  </div></el-col
                >
              </el-row>
            </div>
          </div>
          <div v-if="state == -2">
            <div style="padding: 15px; background: #f5f5f5">预约结果</div>
            <div style="padding: 15px">
              <el-row style="margin-bottom: 16px">
                <el-col :span="6"><div>预约状态:已取消</div></el-col>
                <el-col :span="6"
                  ><div>
                    操作人员:{{ updateOperationInfo.userName }}
                  </div></el-col
                >
                <el-col :span="6"
                  ><div>
                    操作时间:{{ updateOperationInfo.operationTime }}
                  </div></el-col
                >
              </el-row>
              <el-row>
                <el-col :span="6"
                  ><div>取消原因:{{ cancelInfo.cancelCause }}</div></el-col
                >
                <el-col :span="6"
                  ><div>取消备注:{{ cancelInfo.cancelRemark }}</div></el-col
                >
                <el-col :span="6"
                  ><div>取消时间:{{ cancelInfo.operationTime }}</div></el-col
                >
              </el-row>
            </div>
          </div>

          <!-- 未确认 -->
          <div style="padding: 15px; background: #f5f5f5" v-if="state == 1">
            确认预约信息
          </div>
          <div v-if="state == 1">
            <div style="padding: 10px 15px">
              <el-row style="margin-bottom: 16px">
                修改预约:
                <el-radio v-model="resvere" label="2">否</el-radio>
                <el-radio v-model="resvere" label="1">是</el-radio>
              </el-row>
              <div v-if="resvere == '1'">
                <el-row style="margin-bottom: 16px">
                  预约日期:
                  <el-select
                    v-model="changeReserveDate"
                    placeholder="请选择"
                    style="width: 180px"
                  >
                    <el-option
                      v-for="item in days"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </el-row>
                <el-row style="margin-bottom: 16px">
                  预约时间:
                  <el-time-select
                    style="width: 180px; margin-bottom: 10px"
                    v-model="time"
                    :picker-options="{
                      start: '08:00',
                      step: '00:60',
                      end: '22:00',
                    }"
                    value-format="HH:mm"
                    format="HH:mm"
                    placeholder="请选择预约时间"
                  >
                  </el-time-select>
                </el-row>
                <el-row style="margin-bottom: 16px">
                  预约备注:
                  <el-input
                    type="textarea"
                    v-model="changeRemark"
                    style="width: 150px"
                  ></el-input>
                </el-row>
              </div>
              <div v-else>
                <el-row style="margin-bottom: 16px">
                  确认备注:
                  <el-input
                    type="textarea"
                    v-model="confirmRemark"
                    style="width: 150px"
                  ></el-input>
                </el-row>
              </div>
            </div>
          </div>
          <!-- 未确认结束 -->

          <!-- 未到店 -->
          <div v-if="state == 2">
            <div style="padding: 15px; background: #f5f5f5">确认预约结果</div>
            <div style="padding: 10px 15px">
              <el-row style="margin-bottom: 16px">
                预约情况:
                <el-radio v-model="arrival" label="2">已到店</el-radio>
              </el-row>
              <div v-if="arrival == '2'">
                <el-row style="margin-bottom: 16px">
                  到店时间:
                  <el-date-picker
                    v-model="arrivalTime"
                    type="datetime"
                    value-format="yyyy-MM-dd H:mm:ss"
                  >
                  </el-date-picker>
                </el-row>

                <el-row style="margin-bottom: 16px">
                  到店备注:
                  <el-input
                    type="textarea"
                    v-model="arrivalReamrk"
                    style="width: 150px"
                  ></el-input>
                </el-row>
              </div>
              <!-- 取消 -->
              <div v-else>
                <el-row style="margin-bottom: 16px">
                  取消原因:
                  <el-select v-model="cancelCause" placeholder="请选择">
                    <el-option
                      v-for="item in cancelCauseList"
                      :key="item._id"
                      :label="item.item_name"
                      :value="item.item_name"
                    >
                    </el-option>
                  </el-select>
                </el-row>
                <el-row style="margin-bottom: 16px">
                  取消备注:
                  <el-input
                    type="textarea"
                    v-model="cancelRemark"
                    style="width: 150px"
                  ></el-input>
                </el-row>
              </div>
            </div>
          </div>
        </div>
        <div style="height: 80px"></div>
      </el-scrollbar>
      <!-- 未确认预约非洗美 -->
      <div class="btnBox" v-if="state == 1">
        <div class="btnItem" @click="drawerStatus = false">取消</div>
        <div class="btnItem submit" @click="submit1">保存</div>
      </div>
      <!-- 未到店预约非洗美 -->
      <div class="btnBox" v-if="state == 2">
        <div class="btnItem" @click="drawerStatus = false">取消</div>
        <div class="btnItem submit" @click="submit2">保存</div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      default: "",
    },
    arrivalState: {
      default: "",
    },
  },
  data() {
    return {
      // 已到店
      arrivalInfo: {
        arrivalReamrk: "",
        operationTime: "",
      },
      // 已取消
      cancelInfo: {
        cancelCause: "",
        cancelRemark: "",
        operationTime: "",
      },
      arrivalTime: this.$moment().format("YYYY-MM-DD H:mm:ss"),
      state: "", // 1 未确认 2 未到店 3 已到店 -2 已取消 0已删除
      // 预约时间 预约日期
      changeReserveDate: "",
      cancelCauseList: [],
      cancelCause: "",
      time: "",
      changeRemark: "", //修改备注
      confirmRemark: "", //确认备注
      days: [], //时间列表
      resvere: "2", //修改预约
      arrival: "2", //到店状态
      drawerStatus: false,
      arrivalReamrk: "", //到店备注
      cancelRemark: "", //未到到店取消备注
      userId: "",
      userName: "",
      linkmanMobile: "",
      reserveType: "",
      // 回访人员
      updateOperationInfo: {
        operationTime: "",
        userId: "",
        userName: "",
      },
      confirmInfo: {
        confirmRemark: "",
      },
      reserveList: ["洗美", "医疗", "寄养", "看宠"],
      operationTime: "", //创建时间
      memberPetList: [], //寄养宠物
      remark: "",
      reserveDate: "", //预约日期
      // 医疗
      medicalInfo: {
        medicalPro: {
          name: "",
          id: "",
        },
        petId: "",
        petName: "",
      },
      // 寄养信息
      fosterInfo: {
        petIds: [],
        petName: [],
      },
      // 用户宠物列表
      // memberPetList:[],
      // 看宠
      seePetInfo: {
        petClass: {
          name: "",
          id: "",
        },
        petType: {
          name: "",
          id: "",
        },
      },
    };
  },
  mounted() {
    if (this.id) {
      this.getReserveRecord();
    }
    if (this.arrivalState) {
      this.arrival = this.arrivalState;
    } else {
      this.arrival = "2";
    }
    this.$nextTick(() => {
      this.drawerStatus = true;
      this.getDataList();
      this.getDataBase();
    });
  },
  methods: {
    // 未到店
    submit2() {
      if (this.arrival == "2") {
        // 到店
        // console.log("修改");
        let params = {
          id: this.id,
          arrivalInfo: {
            operationTime: this.arrivalTime,
            userId: this.userId,
            userName: this.userName,
            arrivalReamrk: this.arrivalReamrk,
          },
        };
        // console.log("params到店确认", params);
        let loading = this.$loading();
        this.$http
          .post(process.env.VUE_APP_AppAdmin + "/api/Resvere/Arrival", params)
          .then((res) => {
            loading.close();
            if (res.code == 0) {
              // console.log("res确定到店", res);
              // this.drawerStatus = false;
              this.$emit("submit");
            }
          });
      }
    },
    // 获取字典配置
    getDataBase() {
      let loading = this.$loading();
      this.$http
        .get(
          process.env.VUE_APP_zichan +
            "/api/SystemConfig/GetSystemDictionByCode",
          { code: "quxiaoyuyue" }
        )
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            // console.log("字典信息", res);
            this.cancelCauseList = res.data.item_list || [];
          }
        });
    },

    //保存未确认预约非洗美预约
    submit1() {
      if (this.resvere == "1") {
        if (this.$public.isNull(this.changeReserveDate)) {
          this.$message({
            message: "请输入选择预约日期",
            type: "error",
          });
          return;
        }
        if (this.$public.isNull(this.time)) {
          this.$message({
            message: "请输入选择预约时间",
            type: "error",
          });
          return;
        }
        let params = {
          id: this.id,
          reserveDate: this.changeReserveDate + " " + this.time,
        };
        // console.log("params", params);
        let loading = this.$loading();
        this.$http
          .post(
            process.env.VUE_APP_AppAdmin + "/api/Resvere/UpdateReserveDate",
            params
          )
          .then((res) => {
            loading.close();
            if (res.code == 0) {
              // console.log("res修改信息", res);
              // this.drawerStatus = false;
              this.$emit("submit");
            }
          });
      } else {
        let params = {
          id: this.id,
          confirmInfo: {
            operationTime: this.$moment().format("YYYY-MM-DD H:mm:ss"),
            userId: this.userId,
            userName: this.userName,
            confirmRemark: this.confirmRemark,
          },
        };
        // console.log("params", params);
        let loading = this.$loading();
        this.$http
          .post(process.env.VUE_APP_AppAdmin + "/api/Resvere/Confirm", params)
          .then((res) => {
            loading.close();
            if (res.code == 0) {
              // console.log("res确认到店", res);
              // this.drawerStatus = false;
              this.$emit("submit");
            }
          });
        // console.log("不修改");
      }
    },
    //返回最近七天的日期
    getDataList() {
      let days = [];
      let data = new Date();
      for (let i = 0; i <= 24 * 6; i += 24) {
        //今天加上后6天
        let dateItem = new Date(data.getTime() + i * 60 * 60 * 1000); //使用当天时间戳加上以前的时间毫秒（小时*分*秒*毫秒）
        let y = dateItem.getFullYear(); //获取年份
        let m = dateItem.getMonth() + 1; //获取月份js月份从0开始，需要+1
        let d = dateItem.getDate(); //获取日期
        m = this.addDate0(m); //给为单数的月份补零
        d = this.addDate0(d); //给为单数的日期补零
        let valueItem = y + "-" + m + "-" + d; //组合
        days.push(valueItem); //添加至数组
      }
      // console.log("最近七天日期：", days);
      this.days = days;
    },
    //给日期加0
    addDate0(time) {
      if (time.toString().length == 1) {
        time = "0" + time.toString();
      }
      return time;
    },
    // 获取详情
    getReserveRecord() {
      let loading = this.$loading();
      this.$http
        .get(process.env.VUE_APP_AppAdmin + "/api/Resvere/GetReserveRecord", {
          id: this.id,
        })
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            console.log("预约详情", res);
            this.state = res.data.state;
            this.userId = res.data.userId;
            this.reserveType = res.data.reserveType;
            this.updateOperationInfo =
              res.data.updateOperationInfo || this.updateOperationInfo;
            this.confirmInfo = res.data.confirmInfo || this.confirmInfo;
            this.userName = res.data.linkmanName;
            this.linkmanMobile = res.data.linkmanMobile;
            this.operationTime = res.data.createOperationInfo.operationTime;
            this.confirmInfo = res.data.confirmInfo || this.confirmInfo;
            this.memberPetList = res.data.memberPetList || [];
            this.medicalInfo = res.data.medicalInfo || this.medicalInfo;
            this.seePetInfo = res.data.seePetInfo || this.seePetInfo;
            this.fosterInfo = res.data.fosterInfo || this.fosterInfo;
            this.remark = res.data.remark;
            this.changeRemark = res.data.remark;
            this.reserveDate = res.data.reserveDate;
            this.changeReserveDate = res.data.reserveDate.split(" ")[0];
            this.time = res.data.reserveDate.split(" ")[1];
            this.getPetName();
            if (this.state == -2) {
              this.cancelInfo = res.data.cancelInfo;
            }
            // arrivalInfo到店
            if (this.state == 3) {
              this.arrivalInfo = res.data.arrivalInfo;
            }
            //console.log("宠物id", this.medicalInfo.petId);
          }
        });
    },
    // 根据用户id获取宠物的列表
    getPetName() {
      // 医疗
      if (this.reserveType == 2) {
        let index = this.memberPetList.findIndex((a) => {
          return a.petId == this.medicalInfo.petId;
        });
        if (index > -1) {
          this.medicalInfo.petName = this.memberPetList[index].petName;
        } else {
          this.medicalInfo.petName = "";
        }
      } else if (this.reserveType == 3) {
        let arr = [];
        // console.log('this.fosterInfo.petId',this.fosterInfo.petIds);
        this.fosterInfo.petIds.forEach((b) => {
          let index = this.memberPetList.findIndex((a) => {
            return a.petId == b;
          });
          if (index > -1) {
            arr.push(this.memberPetList[index].petName);
            this.fosterInfo.petName = arr;
          } else {
            this.fosterInfo.petName = [];
          }
        });
      }
    },
    //   关闭弹框
    handleClose() {
      this.$emit("submit");
    },
  },
};
</script>

<style scoped lang="scss">
.el-scrollbar__wrap {
  overflow-x: hidden !important;
}
.page {
  font-size: 12px;
  .project {
    width: 139px;
    height: 62px;
    background: #fff4eb;
    border-radius: 5px;
    border: 1px solid #f5882a;
    font-size: 12px;
    color: #f5882a;
    text-align: center;
    box-sizing: border-box;
    padding-top: 18px;
  }
  .btnBox {
    width: 100%;
    font-size: 14px;
    color: #fff;
    line-height: 40px;
    display: flex;
    position: absolute;
    bottom: 0;
    z-index: 10;
    .btnItem {
      text-align: center;
      width: 100%;
      background-color: #d6d6d6;
      cursor: pointer;
      &.submit {
        background-color: $mainColor;
      }
    }
  }
}
</style>